import { PilotHistoryEntry } from '../types';

export const pilotHistoryActions = {
  SET_PILOT_HISTORY_ENTRY: 'SET_PILOT_HISTORY_ENTRY',
}

export const setPilotHistoryEntry = (pilotHistoryEntry: PilotHistoryEntry) => ({
  type: pilotHistoryActions.SET_PILOT_HISTORY_ENTRY,
  payload: { pilotHistoryEntry },
})
